<template>
  <pagerlist
    :tableHeader="this.testpositionlogic.opHeader()"
    :tableData="testPositionList"
    :page="this.testpositionlogic.searchForm.page"
  >
    <template v-slot:btn="slotProps">
      <el-button
        type="primary"
        v-if="slotProps.row.rpid != emptyId"
        @click.stop="edit(slotProps.row)"
      >
        编辑
      </el-button>
    </template>
  </pagerlist>
  <pager
    :page="this.testpositionlogic.searchForm.page"
    :numTotal="numTotal"
    :handleCurrentChange="handleCurrentChange"
  />
  <el-dialog
    :model-value="showDial"
    width="30rem"
    center
    :before-close="noEdit"
  >
    <div class="addFunc_title">修改测量部位</div>
    <hr />
    <div class="xgmm_form">
      <el-form
        ref="editForm"
        :model="modelForm"
        :rules="this.testpositionlogic.rules"
      >
        <el-row>
          <el-col :span="18">
            <el-form-item prop="testPText">
              <div>
                <span><i>*</i>测量部位名称：</span>
                <el-input
                  class="admin_tel input77"
                  v-model="modelForm.testPText"
                  maxlength="30"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item prop="testPCode">
              <div>
                <span><i>*</i>测量部位编码：</span>
                <el-input
                  type="number"
                  class="admin_tel input77"
                  v-model="modelForm.testPCode"
                  maxlength="30"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="sureBtn">
      <el-button class="qx" @click="noEdit('editForm')" type="info"
        >取消</el-button
      >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-button class="qd" @click="okEdit('editForm')" type="primary"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import pagerlist from "@/components/listComponents/pagerList";
import pager from "@/components/listComponents/pager";
export default {
  components: {
    pagerlist,
    pager,
  },
  data() {
    return {
      numTotal: 0,
      testPositionList: [],
      showDial: false,
      modelForm: {},
    };
  },
  mounted() {
    this.handleCurrentChange();
  },
  methods: {
    handleCurrentChange: function (page = 1) {
      this.testpositionlogic.getTestPositionList().then((res) => {
        this.testPositionList = res.testPositionList;
      });
    },
    edit: function (row) {
      this.modelForm = row;
      this.showDial = true;
    },
    noEdit: function () {
      this.$confirm("确认要关闭吗？")
        .then((_) => {
          this.resetForm("editForm");
          this.showDial = false;

          done();
        })
        .catch((_) => {});
    },
    okEdit: function (ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.modelForm.testPCode = Number(this.modelForm.testPCode);
          this.axios
            .post(
              this.baseURL + "Base/EditTestPosition",
              this.modelForm,
              this.headers()
            )
            .then((res) => {
              this.resolveData(res.data, "edit");
              this.showDial = false;
            });
        }
      });
    },
    resetForm: function (refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
  },
};
</script>




